module.exports = __webpack_public_path__ + "img/图层 17.910b0d71.png";